export default __webpack_public_path__ + "static/media/drinkslogo.424e7697.svg";